import { ref, unref } from '@vue/composition-api'
import nominationsApi from '@/services/api/nominations'
import EventBus from '@/store/EventBus'

export default function useNominationsReassign(draftId, type) {
  const candidates = ref([])
  const candidatesTotal = ref(0)
  const candidatesLoading = ref(false)

  const sourceEvents = ref([])
  const sourceLoading = ref(false)

  const toOptions = ref([])
  const toLoading = ref(false)

  async function fetchCandidates(params) {
    candidatesLoading.value = true
    try {
      const res = await nominationsApi.getReassignCandidates(unref(draftId), unref(type), params)
      const data = res.data.data
      candidates.value = Array.isArray(data.items) ? data.items : []
      candidatesTotal.value = data.total != null ? data.total : 0
    } catch (_) {
      candidates.value = []
      candidatesTotal.value = 0
    } finally {
      candidatesLoading.value = false
    }
  }

  async function fetchSource(sourceId) {
    sourceLoading.value = true
    try {
      const res = await nominationsApi.getReassignSource(unref(draftId), unref(type), sourceId)
      sourceEvents.value = Array.isArray(res.data.data) ? res.data.data : []
    } catch (_) {
      sourceEvents.value = []
    } finally {
      sourceLoading.value = false
    }
  }

  async function searchTo(params) {
    toLoading.value = true
    try {
      const res = await nominationsApi.searchReassign(unref(draftId), unref(type), params)
      toOptions.value = Array.isArray(res.data.data) ? res.data.data : []
    } catch (_) {
      toOptions.value = []
    } finally {
      toLoading.value = false
    }
  }

  async function reassign(data) {
    try {
      const res = await nominationsApi.reassign(unref(draftId), unref(type), data)
      if (res.data.message) EventBus.$emit('show-success', res.data.message)
      return true
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        EventBus.$emit('http-error', err.response.data.message)
      }
      return false
    }
  }

  return {
    candidates,
    candidatesTotal,
    candidatesLoading,
    sourceEvents,
    sourceLoading,
    toOptions,
    toLoading,
    fetchCandidates,
    fetchSource,
    searchTo,
    reassign
  }
}



// WEBPACK FOOTER //
// ./src/composables/nominations/useNominationsReassign.js